// extracted by mini-css-extract-plugin
export default {"melodyVideo":"KP-z","isFullWidth":"LP-z","landingPageVideo":"MP-z","play":"NP-z","iframeVideo":"OP-z","playHidden":"PP-z","fullwidth":"QP-z"};